export const shouldRetryWithRefresh = (status: number, errorMessage?: string): boolean => {
  if (status === 401) return true;
  
  if (status === 500) return true;
  
  if (errorMessage) {
    const lowerMessage = errorMessage.toLowerCase();
    if (lowerMessage.includes('token') || 
        lowerMessage.includes('unauthorized') || 
        lowerMessage.includes('authentication') ||
        lowerMessage.includes('internal server error')) {
      return true;
    }
  }
  
  return false;
};

export default shouldRetryWithRefresh;
